import styled from 'styled-components/native'

export const AlreadyBookedAppointmentsNoticeView = styled.View`
  width: 100%;
  background-color: #ffbc22;
  padding: 30px 0;
  margin-top: 35px;
  border-radius: 8px;
`

export const AlreadyBookedAppointmentsNoticeText = styled.Text`
  color: #2e384dce;
  text-align: center;
  padding: 0 10px;
`
